/**
 * Decide whether a delta-synced collection must be fully re-read.
 *
 * Holding every document matters more than saving reads, so any difference
 * with the exact server count triggers a resync:
 * - more local documents → deletes, which a delta query never returns;
 * - fewer local documents → documents the delta query cannot see, e.g. ones
 *   written without `updated_at` by clients that predate delta sync.
 */
export function needsFullResync(
  localCount: number,
  serverCount: number,
): boolean {
  return localCount !== serverCount;
}
